import { pluralize } from 'common/StringUtils';
import { Icon, IconColor } from 'web-common/src/shared/design-system/components/Icon';

interface IngredientsSectionProps {
  ingredients?: string | null;
  numIngredientsFlagged?: number;
}

export const IngredientsSection: React.FC<IngredientsSectionProps> = ({ ingredients, numIngredientsFlagged }) => {
  if (!ingredients) {
    return null;
  }

  const hasFlaggedIngredients = numIngredientsFlagged && numIngredientsFlagged > 0;

  const renderFlaggedAlert = hasFlaggedIngredients ? (
    <div className='mx-auto my-3 flex max-w-[356px] items-center gap-2 rounded bg-strawberry-100 px-4 py-2'>
      <Icon name='info' color={IconColor.STRAWBERRY_500} size={16} />
      <p className='text-label-400 text-strawberry-500'>
        This dish contains{' '}
        <span className='text-label-600'>
          {numIngredientsFlagged} {pluralize('ingredient', numIngredientsFlagged)}
        </span>{' '}
        you've flagged
      </p>
    </div>
  ) : null;

  const renderDisclaimer = (
    <div className='mt-6 flex items-start gap-2'>
      <Icon name='info' color={IconColor.EGGPLANT_500} size={16} />
      <p className='text-label-300 italic text-eggplant-500'>
        Please note that dishes may contain — or may be processed in a facility that contains — allergens such as milk,
        peanuts, tree nuts, wheat, dairy, eggs, fish, shellfish, soy, or sesame.
      </p>
    </div>
  );

  return (
    <div className='w-full py-6 text-left'>
      {/* Ingredients header and content */}
      <div>
        <p className='mb-3 text-caption-700-caps text-eggplant'>Ingredients</p>
        {renderFlaggedAlert}
        <p className='text-body-400 text-eggplant'>{ingredients}</p>
      </div>

      {/* Disclaimer */}
      {renderDisclaimer}
    </div>
  );
};
